import { PayeePickerField, SourcePickerField } from "../EntityPickerField";
import type { InvoiceSenderRef, SenderKind } from "../../logic/invoice-sender";
import type { PayeeId, SourceId } from "../../api/types";

export type InvoiceSenderPickerProps = {
  /** Which registry to pick from. */
  kind: SenderKind;
  /** The picked id for `kind`, or null. */
  value: string | null;
  onChange: (next: InvoiceSenderRef | null) => void;
  required?: boolean;
  size?: "small" | "medium";
};

/**
 * One picker for an invoice's sender: the payee picker or the source picker,
 * depending on `kind`. Shared by the invoice form (under its Payee | Source
 * toggle) and the auto-fill review (fixed to the kind the detector declared).
 */
export const InvoiceSenderPicker = ({
  kind,
  value,
  onChange,
  required,
  size,
}: InvoiceSenderPickerProps) =>
  kind === "payee" ? (
    <PayeePickerField
      required={required}
      size={size}
      value={value as PayeeId | null}
      onChange={(id) => onChange(id ? { kind: "payee", id } : null)}
    />
  ) : (
    <SourcePickerField
      required={required}
      size={size}
      value={value as SourceId | null}
      onChange={(id) => onChange(id ? { kind: "source", id } : null)}
    />
  );
